export default "__VITE_ASSET__DGpw7m2Q__"